import { DateTime } from 'luxon';

export const setDateTime = (selectedDate: string, time: string) => {
  const date = DateTime.fromISO(selectedDate);
  const timeParts = time.split(':');
  const hour = Number(timeParts[0]);
  const minute = Number(timeParts[1]);
  return date.set({ hour, minute, second: 0, millisecond: 0 }).toISO();
};
